// React
import React from 'react';

// Components
import { Loader } from 'components';
import AnimateButton from 'components/@extended/AnimateButton';

// Packages
import { Grid, Stack, Box, Button } from '@mui/material';

const RegistrationReview = ({ submitRegistration, setStep, loading, occupants }) => {
    return (
        <Grid
            item
            sm={8}
            sx={{
                backgroundColor: 'rgba(33, 35, 34, 0.05)',
                height: '100vh',
                padding: '40px',
                display: 'flex',
                justifyContent: 'center',
                alignItems: 'center'
            }}
        >
            {loading && <Loader />}
            <Box>
                <Stack
                    sx={{
                        justifyContent: 'center',
                        alignItems: 'center'
                    }}
                >
                    <h2 className="oeLarge">Please Review Your Account Information</h2>

                    <Stack
                        direction="row"
                        spacing={2}
                        sx={{
                            justifyContent: 'center',
                            alignItems: 'center'
                        }}
                    >
                        <AnimateButton>
                            <Button
                                style={{ width: '100%' }}
                                className="oeGoBack"
                                variant="contained"
                                size="large"
                                onClick={() => {
                                    setStep('occupants');
                                }}
                            >
                                Go Back
                            </Button>
                        </AnimateButton>

                        <AnimateButton>
                            <Button
                                style={{ width: '100%' }}
                                variant="contained"
                                size="large"
                                disabled={!occupants || occupants.length === 0}
                                onClick={() => submitRegistration()}
                            >
                                Submit
                            </Button>
                        </AnimateButton>
                    </Stack>
                </Stack>
            </Box>
        </Grid>
    );
};

export default RegistrationReview;
